import React, { Component } from "react";
import PageLoader from './common/PageLoader';
import "xav-chat-widget/lib/styles.css";
import { fetchBotConfigApi } from '../apis/botApi';
import { SSO_TYPE } from '../utils/constants';
import { guid, setSession, getItemFromSession } from '../utils/common';
const { REACT_APP_BOT_ID } = process.env;


export default class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isPreChatSurvey: false
        };
    }

    async componentDidMount() {
        try {
            const response2=await fetchBotConfigApi(REACT_APP_BOT_ID);
            const botResponse = response2.data;
            let ssoUrl = botResponse.result.sso_auth_url.replace("u0026", "&").replace(/{bot_uid}/g, REACT_APP_BOT_ID);
            const ssoType = botResponse.result.sso_type;
            
            if (ssoType === SSO_TYPE.one_login) {
              let botKind = botResponse.result.bot_kind;
              let relayState = getItemFromSession("relayStateOneLogin") || '';
              const hostName = window.location.hostname;
              relayState = relayState ? relayState : window.btoa(hostName + '_'+ guid() +'_0_'+botResponse.result.uid + '_' + botKind);
              ssoUrl=ssoUrl+"&RelayState="+relayState;
              setSession("relayStateOneLogin", relayState);
              console.log("One Login RelayState", relayState);
            }
            this.setState({ isLoading: false }, () => window.open(ssoUrl,'_self'));
          } catch (error) {
            console.log(error);
            this.setState({isLoading: false})
          }
    }


    render() {
        const { isLoading, isPreChatSurvey } = this.state;
        return (
            <div>
                {isLoading ? <PageLoader /> : null}
            </div>
        )
    }
}

